export const questionsOptional = {
    COLLAR_KI_KO: {
        questionsOptional: ["strike_cap", "strike_floor", "strike_ko", "strike_ki", "nature_de_la_prime_de_couverture"],
    },
    AUTOCALL_RENDEMENT: {
        questionsOptional: ["coupon_conditionnel_maximum", "barriere_de_coupon_conditionnel_minimum", "nombre_de_periodes_avec_un_coupon_garanti", "coupon_garanti"],
    },
    WEDDING_CAKE_OPTIONS: {
        questionsOptional: ["montant_minimum", "montant_maximum", "strike_bonifie", "strike_degrade", "barriere_basse", "barriere_haute"]
    },
    TUNNEL_ASYMETRIQUE: {
        questionsOptional: ["montant_minimum", "montant_maximum", "strike_montant_minimum", "strike_montant_maximum"]
    },
    TERME_PARTICIPATIF: {
        questionsOptional: ["montant_minimum", "montant_maximum", "strike", "ki"]
    },
    TERME_ASYMETRIQUE: {
        questionsOptional: ["montant_minimum", "montant_maximum", "strike"]
    },
    TERME_ASYMETRIQUE_DESACTIVANT: {
        questionsOptional: ["montant_minimum", "montant_maximum", "strike", "ko"]
    },
    TERME_ACCUMULATEUR_KO: {
        questionsOptional: ["montant_minimum", "montant_maximum", "strike", "ko", "borne_basse", "borne_haute", "nombre_de_fixings", "dernier_fixing"]
    },
    TERME_SEC: {
        questionsOptional: ["montant_minimum"]
    },
    TARF: {
        questionsOptional: ["montant_minimum", "montant_maximum", "strike", "borne_basse", "borne_haute", "nombre_de_fixings", "dernier_fixing", "reserve_de_figure"]
    },
    WEDDING_CAKE_ACCUMULATEUR: {
        questionsOptional: ["montant_minimum", "montant_maximum", "strike_bonifie", "strike_degrade", "borne_basse", "borne_haute", "nombre_de_fixings", "dernier_fixing"]
    },
    SWAP: {
        questionsOptional: ["strike_floor", "taux_fixe", "nature_de_la_prime_de_couverture"],
    },
    CAP: {
        questionsOptional: ["strike_cap", "strike_floor", "nature_de_la_prime_de_couverture"],
    },
    COLLAR: {
        questionsOptional: ["strike_cap", "strike_floor", "nature_de_la_prime_de_couverture"],
    }, 
    SWAP_KO: {
        questionsOptional: ["strike_ko", "strike_floor", "nature_de_la_prime_de_couverture"],
    },
    CAP_KO: {
        questionsOptional: ["strike_ko", "strike_floor", "strike_cap", "nature_de_la_prime_de_couverture"],
    },
    COLLAR_KO: {
        questionsOptional: ["strike_ko", "strike_floor", "strike_cap", "nature_de_la_prime_de_couverture"],
    },
    DIY_PLACEMENT: {
        questionsOptional: ["coupon_cible", "barriere_de_coupon_conditionnel_minimum"],
    },
    DIY_CHANGE: {
        questionsOptional: ["montant", "montant_minimum", "montant_maximum", "strike", "strike_montant_minimum", "strike_montant_maximum", "ki", "ko", "montant_minimum_fixings", "montant_maximum_fixings", "nombre_de_fixings", "frequence_fixings", "premier_fixing", "dernier_fixing", "livraison", "reserve_de_figure", "barriere_basse", "barriere_haute", "style_de_barriere_basse", "style_de_barriere_haute"]
    }
}


// WEBPACK FOOTER //
// ./src/shared/Gauge/QuestionOptional.ts